import script from "./Contributions.vue?vue&type=script&setup=true&lang=js"
export * from "./Contributions.vue?vue&type=script&setup=true&lang=js"

import "./Contributions.vue?vue&type=style&index=0&id=32b1a334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b1a334"]])

export default __exports__